/************
 Swipers
 ************/

// thumbnails mobile
let productV4ThumbnailImages = new Swiper("#productV4ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV4ThumbnailsNext',
        prevEl: '#productV4ThumbnailsPrev',
    },
});

// main swiper
let productV4Images = new Swiper("#productV4Swiper", {
    navigation: {
        nextEl: '#productV4Swiper .swiper-button-next',
        prevEl: '#productV4Swiper .swiper-button-prev',
    },
    loop: true,
    thumbs: {
        swiper: productV4ThumbnailImages
    }
});

// open video
document.querySelector("#productV4FormGroupHeaderVideo")?.addEventListener("click", function (e) {
    e.preventDefault();
    const popup = document.querySelector(".videoPopup");
    popup.showModal();
    popup.querySelector("video").play();
});

// gallery desktop
document.querySelectorAll(".productV4GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV4Images.slideTo(index);
    });
});

/*****************
 Reviews
 ****************/

// smooth scroll to reviews
document.querySelector("#productV4Review").addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})

// fetch reviews
fetch(`https://loox.io/widget/Vyep6Ccp8K/ratings?products_ids=${document.querySelector("#productV4Review").dataset.auProductId}`)
    .then(response => response.json())
    .then(data => {
        // update review count
        document.querySelector("#productV4ReviewRating").textContent = `${data.ratings[0].rating}/5`;
        document.querySelector("#productV4ReviewRaters").textContent = `${data.ratings[0].raters} Reviews`;

        // add json ld
        let script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Product",
            "name": "Vibit eStim - Wireless Electrical Muscle Stimulator",
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": `${data.ratings[0].rating}`,
                "reviewCount": data.ratings[0].raters
            }
        });
    });

/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV4() {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV4FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV4FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV4FormVariants").value)
        })[0];
    }

    // find variant image
    if (activeVariant.featured_image) {
        const variantImage = document.querySelector(`.productV4SwiperSlide[id="${activeVariant.featured_image.id}"]`);
        if (variantImage) {
            productV4Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // update pricing (check for bundle discount)
    if (document.querySelector("#productV4Bundle")) {
        // parse discount from the selected bundle
        quantity = parseInt(document.querySelector(".productV4BundleOptionsItemInput:checked").value);
        discount = parseInt(document.querySelector(".productV4BundleOptionsItemInput:checked").getAttribute("data-discount"));

        // check if any of the selected items are out of stock
        document.querySelectorAll(`.productV4FormGroup.active .productV4FormGroupFlexColor:checked`).forEach(function (element) {
            if (element.dataset.available === "false") {
                isAvailable = false;
            }
        });
    }

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for addon
    const hasAddon = document.querySelector("#productV4AddonCheckboxInput:checked")
    if (hasAddon) {
        total += parseInt(document.querySelector(".productV4AddonFormVariantsItem:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV4AddonFormVariantsItem:checked").dataset.compare);
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        const prefix = hasAddon ? "BUNDLE" : "SALE";
        document.querySelector("#productV4PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV4PriceActual").textContent = `${prefix} ${price(total, true)}`;
        document.querySelector("#productV4PriceSavings span").textContent = `SAVE ${savingsPercent}% (${price(savings, true)})`;
        document.querySelector("#productV4PriceSavings").classList.add('active');
    } else {
        document.querySelector("#productV4PriceCompare").textContent = "";
        document.querySelector("#productV4PriceActual").textContent = price(total, true);
        document.querySelector("#productV4PriceSavings").classList.remove('active');
    }

    // update BOGO box prices
    let BOGOExists = document.querySelector('.productV4BOGO') || false;
    if (BOGOExists) {
        document.querySelector('.productV4BOGOPriceReal').textContent = price(activeVariant.price, true);
        document.querySelector('.productV4BOGOPriceCompare').textContent = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            document.querySelector('.productV4BOGOPriceCompare').textContent = price(activeVariant.compare_at_price, true);
        }
    }

    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV4ATC").classList.remove("oos");
        document.querySelector("#productV4ATC").textContent = `Add To Cart — ${price(total, true)}`;
    } else {
        document.querySelector("#productV4ATC").classList.add("oos");
        document.querySelector("#productV4ATC").textContent = "Sold Out — Notify Me When Available";
    }
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV4FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.querySelector(".productV4FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV4();
    });
});

// variant dropdown support on change
document.querySelector("#productV4FormVariants")?.addEventListener("change", updateProductV4);

/***********************
 Product Bundle (Vibit Roll)
 *********************/

/*
Bundle is only shown on the vibit roll page
Bundle allows the user to change how many form groups are shown
 */

if (document.querySelector("#productV4Bundle")) {
    // on input change
    document.querySelectorAll(`.productV4BundleOptionsItemInput`).forEach(function (element) {
        element.addEventListener("change", function () {
            // get index to know how many groups to show in the productV4 form
            let index = parseInt(this.value);

            // hide all productV4 form groups
            document.querySelectorAll(".productV4FormGroup").forEach(function (element) {
                element.classList.remove("active");
            });

            // show the correct number of productV4 form groups
            for (let i = 0; i < index; i++) {
                document.querySelectorAll(".productV4FormGroup")[i].classList.add("active");
            }

            // update price
            updateProductV4();
        });
    });
}

// if url has bundle, preselect it
if (urlParams.has("bundle")) {
    document.querySelector(`.productV4BundleOptionsItemInput[value="${urlParams.get("bundle")}"]`)?.parentElement.click();
}

/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV4QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV4QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV4QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV4QuantityValue").textContent = quantity;
});

/***************
 Product Addon
 ****************/

// select addon
if (document.querySelector("#productV4Addon")) {
    // input change
    document.querySelector("#productV4AddonCheckboxInput").addEventListener("change", function () {
        // update product form
        updateProductV4();

        // on check
        if (this.checked) {
            // update active class on parent
            document.querySelector("#productV4Addon").classList.add("active");

            // switch slides
            productV4Images.slideTo(productV4Images.slides.length - 1);
        } else {
            // remove active class on parent
            document.querySelector("#productV4Addon").classList.remove("active");
        }
    });

    // variant selection change
    document.querySelectorAll(".productV4AddonFormVariantsItem").forEach(function (element) {
        element.addEventListener("change", updateProductV4);
    });

    // if url has addon, preselect it
    if (urlParams.has("addon")) {
        document.querySelector("#productV4AddonCheckbox").click();
    }
}

/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV4ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // determine which time of productV4 we're adding to cart
    // 1. Bundle
    // 2. Single Product

    // create form data
    let formData = {
        items: []
    };

    // check for BOGO
    let BOGOExists = document.querySelector('.productV4BOGO') || false;
    if (BOGOExists) {
        quantity = 2;
    }

    // check for bundle
    if (document.querySelector("#productV4Bundle")) {
        // add each item to the form data
        document.querySelectorAll(".productV4FormGroup.active .productV4FormGroupFlexColor:checked").forEach(function (element) {
            formData.items.push({
                quantity: 1,
                id: parseInt(element.value),
                // important note here, since somebody can select 3 of the same color, we need to add a unique source for each item
                properties: {
                    "__source": element.getAttribute("name")
                }
            });
        });
    }
    // normal product
    else {
        formData.items.push({
            quantity: quantity,
            id: activeVariant.id,
        });
    }

    // check if addon
    const hasAddon = !!document.querySelector("#productV4AddonCheckboxInput:checked");
    if (hasAddon) {
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV4AddonFormVariantsItem:checked").value),
        });
    }

    // check if vibit roll, add tutorial video
    if (product.handle === "the-vibit" || hasAddon) {
        formData.items.push({
            quantity: 1,
            id: tutorial.variants[0].id,
        });
    }

    // check for neck stretch
    if (Shopify.shop === "vibit-com-au.myshopify.com" && product.handle === "neck-stretch") {
        formData.items.push({
            quantity: 1,
            id: neckStretchEbook.variants[0].id,
        })
    }

    // add productV4
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV4ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV4AddonCheckboxInput").checked) {
            document.querySelector("#productV4AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV4ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV4ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV4ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV4Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV4DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

